import { render, staticRenderFns } from "./CenteredLayout.vue?vue&type=template&id=12e48fc5&scoped=true&"
import script from "./CenteredLayout.vue?vue&type=script&lang=js&"
export * from "./CenteredLayout.vue?vue&type=script&lang=js&"
import style0 from "./CenteredLayout.vue?vue&type=style&index=0&id=12e48fc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e48fc5",
  null
  
)

export default component.exports